import React, { useState } from 'react';
import Colors from './Colors';
import { Link } from 'react-router-dom';
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div style={{
      position: 'fixed',
      top: '0px',
      textAlign: 'center',
      alignContent: 'center',
      width: '100%',
      background: Colors.primary,
      color: Colors.white,
      zIndex: '100',
      display: 'flex',
      justifyContent: 'center',
      padding: '4px'
    }}>
      <h4>Hafiz Traders</h4>
      
      {/* Menu Icon */}
      <div onClick={toggleMenu} style={{ cursor: 'pointer',position:'fixed', right:'8px',top:'24px' }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke={Colors.white}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-menu"
        >
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </div>

      {/* Dropdown Menu */}
      {menuOpen && (
        <div style={{
          display:'flex',
          justifyContent:'center',
          alignItems:'center',
          flexDirection:'column',
          position: 'fixed',
          top: '50px',
          right: '20px',
          background: Colors.white,
          color: Colors.primary,
          border: `1px solid ${Colors.primary}`,
          borderRadius: '4px',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          zIndex: '101'
        }}>
          <ul style={{ display:'flex',
          justifyContent:'center',
          alignItems:'center',
          flexDirection:'column',
          listStyleType: 'none', margin: 0, padding: '10px', textAlign: 'left' }}>
            <Link to="/booker" style={{ padding: '5px 10px', cursor: 'pointer' }} >Booker</Link>
            <Link to="/route" style={{ padding: '5px 10px', cursor: 'pointer' }}>Routes</Link>
            <Link to="/customerlogs" style={{ padding: '5px 10px', cursor: 'pointer' }}>Customer Logs</Link>
            <Link to="" style={{ padding: '5px 10px', cursor: 'pointer' }}>Nothing</Link>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Header;
